export var Role;
(function (Role) {
    Role["ANONYMOUS"] = "ANONYMOUS";
    Role["ADMIN"] = "ADMIN";
    Role["INTERVISOR"] = "INTERVISOR";
    Role["OPERATOR"] = "OPERATOR";
    Role["CLIENT"] = "CLIENT";
})(Role || (Role = {}));
export var MessageType;
(function (MessageType) {
    MessageType["STANDARD_FROM_CLIENT"] = "STANDARD_FROM_CLIENT";
    MessageType["STANDARD_FROM_OPERATOR"] = "STANDARD_FROM_OPERATOR";
    MessageType["CLOSING"] = "CLOSING";
    MessageType["PAUSING"] = "PAUSING";
})(MessageType || (MessageType = {}));
export var ConversationState;
(function (ConversationState) {
    ConversationState["CREATED"] = "CREATED";
    ConversationState["STARTED"] = "STARTED";
    ConversationState["ENDED"] = "ENDED";
    ConversationState["ARCHIVED"] = "ARCHIVED";
})(ConversationState || (ConversationState = {}));
export var DefinedMessageType;
(function (DefinedMessageType) {
    DefinedMessageType["OPERATOR_CHAT_MESSAGE"] = "OPERATOR_CHAT_MESSAGE";
    DefinedMessageType["OPERATOR_CHAT_ENDING_MESSAGE"] = "OPERATOR_CHAT_ENDING_MESSAGE";
    DefinedMessageType["HOME_INFO"] = "HOME_INFO";
    DefinedMessageType["HOME_INFO_NO_OPERATOR"] = "HOME_INFO_NO_OPERATOR";
    DefinedMessageType["CLIENT_WAITING_ROOM_INFO"] = "CLIENT_WAITING_ROOM_INFO";
    DefinedMessageType["CLIENT_WAITING_ROOM_NO_OPERATOR"] = "CLIENT_WAITING_ROOM_NO_OPERATOR";
})(DefinedMessageType || (DefinedMessageType = {}));
